var Handlebars = require("C:\\Users\\fatima elmaachi\\PhpstormProjects\\bn_dist87_hotel-seaside.ch\\Build\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + alias1((lookupProperty(helpers,"date--convert-moment")||(depth0 && lookupProperty(depth0,"date--convert-moment"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"today") : depth0)) != null ? lookupProperty(stack1,"date") : stack1),"DD.MM.YYYY",{"name":"date--convert-moment","hash":{},"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":2,"column":57}}}))
    + " | <i class=\"weather-icon weather-icon--"
    + alias1(alias2(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"today") : depth0)) != null ? lookupProperty(stack1,"symbol") : stack1)) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
    + "\"></i> | "
    + alias1(alias2(((stack1 = ((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"trans"))) && lookupProperty(stack1,"text"))) && lookupProperty(stack1,"min")), depth0))
    + " "
    + alias1(alias2(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"today") : depth0)) != null ? lookupProperty(stack1,"tempMin") : stack1)) != null ? lookupProperty(stack1,"min") : stack1), depth0))
    + "&deg; & "
    + alias1(alias2(((stack1 = ((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"trans"))) && lookupProperty(stack1,"text"))) && lookupProperty(stack1,"max")), depth0))
    + " "
    + alias1(alias2(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"today") : depth0)) != null ? lookupProperty(stack1,"tempMax") : stack1)) != null ? lookupProperty(stack1,"max") : stack1), depth0))
    + "&deg;\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"each--up-to")||(depth0 && lookupProperty(depth0,"each--up-to"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data") : depth0),1,{"name":"each--up-to","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":16}}})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./source/hbs/ehotelier/weather/teaserEXT.hbs
// module id = 300
// module chunks = 0